import { Backdrop } from "@gui/components";
import CurrentGun from "./gun";
import Crosshair from "./crosshair";
import HealthBar from "./healthbar";
const GraphicalUserInterface = () => {
    return (<Backdrop>
            <CurrentGun />
            <HealthBar />
            <Crosshair />
        </Backdrop>);
};
export default GraphicalUserInterface;
